import { render, staticRenderFns } from "./ShippingAddressModal.vue?vue&type=template&id=625afef7&"
import script from "./ShippingAddressModal.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports